import axios from 'axios'
import {jsonHeader} from '@/helpers/axiosHeaders'
const state = {
    items: {
        blockEdit:{
            name: 'blockEdit',
            show: false,
        },
        ruleCategory: {
            name: 'ruleCategory',
            show: false
        },
        addRule: {
            name: 'addRule',
            show: false
        },
        removeRule: {
            name: 'removeRule',
            show: false
        },
        removeRuleForever: {
            name: 'removeRuleForever',
            show: false
        },
        removeRules: {
            name: 'removeRules',
            show: false
        },
        removeCatError: {
            name: 'removeCatError',
            show: false
        },
        providerSendLink: {
            name: 'providerSendLink',
            show: false
        },
        couponKickPartner: {
            name: 'couponKickPartner',
            show: false
        },
        constructActionErrorFirstImageSize: {
            name: 'constructActionErrorFirstImageSize',
            show: false
        },
        staffGroup: {
            name: 'staffGroup',
            show: false
        },
        removeStaffGroupError: {
            name: 'removeStaffGroupError',
            show: false
        },
        removeContactGroupError: {
            name: 'removeContactGroupError',
            show: false
        },
        addWorker: {
            name: 'addWorker',
            show: false
        },
		addContact: {
            name: 'addContact',
            show: false
        },
        sectionAdd: {
            name: 'sectionAdd',
            show: false
        },
        sectionRemoveError: {
            name: 'sectionRemoveError',
            show: false
        },
        sectionForbiddenError: {
            name: 'sectionForbiddenError',
            show: false
        },
        addScreenShot: {
            name: 'addScreenShot',
            show: false
        },
        addLink: {
            name: 'addLink',
            show: false
        },
        addVideo: {
            name: 'addVideo',
            show: false
        },
        editDisabled: {
            name: 'editDisabled',
            show: false
        },
        editAdminDisabled: {
            name: 'editAdminDisabled',
            show: false
        },
        errorScreenUpload: {
            name: 'errorScreenUpload',
            show: false
        },
        errorSchemeUpload: {
            name: 'errorSchemeUpload',
            show: false
        },
        recoverRule: {
            name: 'recoverRule',
            show: false
        },
        dismissWorker: {
            name: 'dismissWorker',
            show: false
        },
        refuseWorker: {
            name: 'refuseWorker',
            show: false
        },
		dismissContact: {
            name: 'dismissContact',
            show: false
        },
        kickUnReadAll: {
            name: 'kickUnReadAll',
            show: false
        },
        notify: {
            name: 'notify',
            show: false
        },
        isNotifyReset: {
            name: 'isNotifyReset',
            show: false
        },
        ruleDetail: {
            name: 'ruleDetail',
            show: false
        },
        somethingWentWrong: {
            name: 'somethingWentWrong',
            show: false
        },
        tryingUpdate: {
            name: 'tryingUpdate',
            show: false
        },
		removeDisabled: {
            name: 'removeDisabled',
            show: false
        },
		moveRule: {
            name: 'moveRule',
            show: false
        },
		ruleType: {
            name: 'ruleType',
            show: false
        },
		exitWithoutSave: {
            name: 'exitWithoutSave',
            show: false
        },
		schemeWorker: {
            name: 'schemeWorker',
            show: false
        },
        previewPDF: {
            name: 'previewPDF',
            show: false
        },
        previewPDFNew: {
            name: 'previewPDFNew',
            show: false
        },
		createUser: {
            name: 'createUser',
            show: false
        },
		moveContract: {
            name: 'moveContract',
            show: false
        },
		pdfViewer: {
            name: 'pdfViewer',
            show: false
        },
        userRefuse: {
            name: 'userRefuse',
            show: false
        },
        removeContract: {
            name: 'removeContract',
            show: false
        },
    },
}

// getters
const getters = {

}

const actions = {
    open(context, data) {
        if(data.name && state.items.hasOwnProperty(data.name)) {
            setTimeout(()=>{
                context.commit('open', {name:data.name});
            },10);
        }
    },
}

const mutations = {
    close(state, data) {
        if(data.name && state.items.hasOwnProperty(data.name)) {
            state.items[data.name].show = false;
            if (data.name == 'addRule') {
                if (document.querySelector('.rules')) {
                    document.querySelector('.rules').style.opacity = ''
                }
            }
            document.getElementsByTagName('body')[0].classList.remove("noscroll");
        }
    },
    hideRuleDetail(state, data){
        state.items.ruleDetail.show = data
    },
    open(state, data) {
        if(data.name && state.items.hasOwnProperty(data.name)) {
          // !! В мутациях не дожно быть аякса таймаутов и прочего асинхроного
          //setTimeout(function(){
            state.items[data.name].show = true
          //},10);
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
